import fetch from "auth/FetchInterceptor";

const companyService = {};

companyService.fetchAll = function () {
  return fetch({
    url: "/company",
    method: "get",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
};
companyService.updateCompany = function ({ companyId, company }) {
  return fetch({
    url: "/company/" + companyId,
    method: "put",
    data: company,
  });
};

companyService.getCompany = function (id) {
  return fetch({
    url: "/company/" + id,
    method: "get",
    params: id,
  });
};

companyService.setPost = function (data) {
  return fetch({
    url: "/company",
    method: "post",
    data: data,
  });
};

export default companyService;
